<template>
    <!-- The products of one ใบจัดรถ row, read from its deliveryList document
         (prodList / prodListRt, written by managecar's addSo / addRt). -->
    <div class="sheet-products">
        <div v-if="!row" class="caption grey--text">กำลังโหลด...</div>
        <template v-else>
            <v-simple-table v-if="soLines.length" dense class="mb-1">
                <colgroup>
                    <col style="width: 22%">
                    <col>
                    <col style="width: 10%">
                </colgroup>
                <thead>
                    <tr>
                        <th>รหัสสินค้า</th>
                        <th>รายละเอียดสินค้า</th>
                        <th class="text-right">จำนวน</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(p, i) in soLines" :key="'so' + i">
                        <td>{{ p.code }}</td>
                        <td>{{ p.name }}<div v-if="p.note" class="caption grey--text">{{ p.note }}</div></td>
                        <td class="text-right">{{ p.qty }}</td>
                    </tr>
                </tbody>
            </v-simple-table>
            <template v-if="rtLines.length">
                <div class="caption red--text font-weight-bold mt-1">สินค้ารับคืน</div>
                <v-simple-table dense>
                    <colgroup>
                        <col>
                        <col style="width: 10%">
                        <col style="width: 30%">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>รายละเอียดสินค้า</th>
                            <th class="text-right">จำนวน</th>
                            <th>สาเหตุ</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(p, i) in rtLines" :key="'rt' + i">
                            <td>{{ p.name || p.code }}</td>
                            <td class="text-right">{{ p.qty }}</td>
                            <td>{{ p.remark }}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </template>
            <div v-if="!soLines.length && !rtLines.length" class="caption grey--text">ไม่มีรายการสินค้า</div>
        </template>
    </div>
</template>

<script>
import I from '@/components/installTime'

// SAP sends the item description as prodName (RDR1.Dscription, in GetProdList
// and GetRtProdList alike) and the line's own free text as desc (RDR1.Text,
// usually blank). productName falls back to the code when there is no
// description, so a name equal to the code is blank here, never printed twice.
// A return carries no code at all, only prodName.
function line (row) {
    const code = I.productCode(row)
    const name = I.productName(row)
    const note = row.desc != null ? String(row.desc).trim() : ''
    return { code, name: name === code ? '' : name, note, qty: I.productQty(row), remark: row.remark }
}

export default {
    props: {
        row: { type: Object, default: null }
    },
    computed: {
        soLines () {
            return (this.row && Array.isArray(this.row.prodList)) ? this.row.prodList.map(line) : []
        },
        rtLines () {
            return (this.row && Array.isArray(this.row.prodListRt)) ? this.row.prodListRt.map(line) : []
        }
    }
}
</script>

<style scoped>
/* Fixed layout, so every opened row's columns line up with the others
   instead of each table sizing itself to its own text. */
.sheet-products >>> table {
    table-layout: fixed;
}
</style>
